import { Component, OnInit } from '@angular/core';
import { FilterChangedEvent, IFloatingFilter } from 'ag-grid-community';

@Component({
  selector: 'app-refresh-grid',
  templateUrl: './refresh-grid.component.html',
  styleUrls: ['./refresh-grid.component.scss']
})
export class RefreshGridComponent implements IFloatingFilter {
   params: any;
    constructor() { }
    onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent): void {
       throw new Error("Method not implemented."); }

   agInit(params: any): void {this.params = params;} 
   resetFilters() 
   { this.params.api.setFilterModel(null); }

}
